import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Sidebar.css';
import { auth } from '../lib/firebase';
import { signOut } from 'firebase/auth';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSignOutAlt, faHome, faCog, faExchangeAlt, faUsers, faDownload } from '@fortawesome/free-solid-svg-icons';
import { useAuthState } from 'react-firebase-hooks/auth';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../lib/firebase';
import { dummy } from '../assets';

const Sidebar = ({ isOpen, toggleSidebar }) => {
  // Hook to get the currently authenticated user
  const [user] = useAuthState(auth);
  // State to store user profile data
  const [profileData, setProfileData] = useState({});
  // Hook to get the current location/path
  const location = useLocation();

  useEffect(() => {
    // Fetch user profile data if the user is authenticated
    if (user) {
      const fetchProfileData = async () => {
        try {
          // Reference to the user's document in Firestore
          const docRef = doc(db, 'users', user.uid);
          const docSnap = await getDoc(docRef);

          // Check if the document exists and update state
          if (docSnap.exists()) {
            setProfileData(docSnap.data());
          } else {
            console.log('No such document!');
          }
        } catch (error) {
          console.error('Error fetching profile data:', error);
        }
      };

      fetchProfileData();
    }
    // Dependency array to re-run the effect when the user changes
  }, [user]);

  const handleLogout = () => {
    // Sign out the user and handle any errors
    signOut(auth).catch((error) => {
      console.error('Error signing out:', error);
    });
    // Close the sidebar after logging out
    toggleSidebar();
  };

  // Determine if the current path matches the link path
  const isActive = (path) => location.pathname === path;

  return (
    <div className={`sidebar ${isOpen ? 'open' : ''}`}>
      {/* Display user information if the user is authenticated and profile data is available */}
      {user && profileData && (
        <div className="user-info">
          {/* Link to the current user's profile */}
          <Link to={`/users/${user.uid}`} className='myLink'>
            <img src={profileData.profilePictureUrl ? profileData.profilePictureUrl : dummy} alt="User" className="user-image" />
            <h3>{profileData.fullName}</h3>
            <p>{profileData.email}</p>
          </Link>
        </div>
      )}

      {/* Navigation links */}
      <div className="nav flex-column">
        {/* Default Route to Dashboard */}
        <Link
          to="/"
          className={`nav-links ${isActive('/') ? 'active' : ''}`}
          onClick={toggleSidebar}
        >
          <FontAwesomeIcon icon={faHome} className='icon ' /> Dashboard
        </Link>

        {/* Route to all users */}
        <Link
          to="/users"
          className={`nav-links ${isActive('/users') ? 'active' : ''}`}
          onClick={toggleSidebar}
        >
          <FontAwesomeIcon icon={faUsers} className='icon ' /> All Users
        </Link>

        {/* Route to add transactions */}
        <Link
          to="/add-transaction"
          className={`nav-links ${isActive('/add-transaction') ? 'active' : ''}`}
          onClick={toggleSidebar}
        >
          <FontAwesomeIcon icon={faExchangeAlt} className='icon ' /> Add Transactions
        </Link>

        {/* Route to settings */}
        <Link
          to="/settings"
          className={`nav-links ${isActive('/settings') ? 'active' : ''}`}
          onClick={toggleSidebar}
        >
          <FontAwesomeIcon icon={faCog} className='icon ' /> Wallet Settings
        </Link>

        {/* Route to download */}
        <Link
          to="/download"
          className={`nav-links ${isActive('/download') ? 'active' : ''}`}
          onClick={toggleSidebar}
        >
          <FontAwesomeIcon icon={faDownload} className='icon ' /> Download App
        </Link>


        {/* Route to logout */}
        <button className="nav-links" onClick={handleLogout}>
          <FontAwesomeIcon icon={faSignOutAlt} className='icon ' /> Logout
        </button>
      </div>
    </div>
  );
};

export default Sidebar;
